import React from 'react';

interface DataManagementIconProps {
  className?: string;
}

const DataManagementIcon: React.FC<DataManagementIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="m6 15c.553 0 1 .448 1 1v3c0 .552-.447 1-1 1s-1-.448-1-1v-3c0-.552.447-1 1-1zm4-4c-.553 0-1 .448-1 1v7c0 .552.447 1 1 1s1-.448 1-1v-7c0-.552-.447-1-1-1zm14 10.833c0 1.377-1.641 2.167-4.5 2.167s-4.5-.79-4.5-2.167v-7.333c0-.883 1.85-1.5 4.5-1.5s4.5.617 4.5 1.5zm-4.5-5.833c-.956 0-1.802-.083-2.5-.227v1.769c.249.165.996.458 2.5.458 1.48 0 2.237-.31 2.5-.489v-1.737c-.698.144-1.544.227-2.5.227zm2.5 5.607v-1.938c-.662.201-1.48.331-2.5.331-1.041 0-1.85-.127-2.5-.321v1.928c.296.16 1.114.393 2.5.393s2.204-.233 2.5-.393zm-9-11.607c-1.654 0-3-1.346-3-3v-4.953c-.162-.016-.321-.047-.485-.047h-4.515c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h7c.553 0 1 .448 1 1s-.447 1-1 1h-7c-2.757 0-5-2.243-5-5v-14c0-2.757 2.243-5 5-5h4.515c1.869 0 3.627.728 4.95 2.05l3.484 3.486c1.173 1.172 1.894 2.729 2.028 4.383.045.55-.365 1.033-.916 1.078-.586.056-1.064-.418-1.092-.997h-4.97zm0-2h4.316c-.218-.378-.468-.738-.781-1.05l-3.484-3.485c-.315-.315-.675-.564-1.051-.781v4.316c0 .551.448 1 1 1z"/>
    </svg>
  );
};

export default DataManagementIcon;
